import { Component } from '@angular/core';
import { DYNCONTENT } from './content-array';
import { FileService } from './file.service';
import * as fileSaver from 'file-saver';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor() {
    
  }
  title = 'CocherlFamilyFoundationAngular';
  dynContent = DYNCONTENT;
}
